module.exports = __webpack_public_path__ + "img/meh-blank.4142bc25.svg";